const MORE_DETAILS_WIDTH = '67px';

const SHIELDS_SRC = {
	error: '/assets/toasts/toast-error.webp',
	success: '/assets/toasts/toast-success.webp',
	information: '/assets/toasts/toast-information.webp'
};

export { MORE_DETAILS_WIDTH, SHIELDS_SRC };
